import { readable } from 'svelte/store';
import { DeserializableMap } from '../api/deserializableMap';
import { ExerciseData } from '../dataTypes/exerciseData';
import jsonExerciseDatas from '../data/exerciseDatas.json';
const exerciseDatasArray = new Array();
const getExerciseID = (exerciseData) => {
    exerciseData.index = exerciseDatasArray.length;
    exerciseDatasArray.push(exerciseData);
    return exerciseData.id;
};
const exerciseDatas = new DeserializableMap(ExerciseData, getExerciseID).deserialize(jsonExerciseDatas);
const exerciseDatasStore = readable(exerciseDatas, set => {
    set(exerciseDatas);
});
export { ExerciseData, exerciseDatasStore, exerciseDatasArray };
